import React from 'react';
import Link from 'next/link';
import { useTranslations } from '../../locales/useTranslations';
import { BiInfoCircle, BiLinkExternal } from 'react-icons/bi';

// Arbeitsort formatieren
function formatLocation(arbeitsort) {
    if (arbeitsort?.toLowerCase() === 'remote') {
        return 'Remote';
    }
    return arbeitsort || '';
}

// Slug generieren aus Titel
function generateSlug(title, jobId) {
    if (!title) return String(jobId);
    const slug = title
        .toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .replace(/ä/g, 'ae')
        .replace(/ö/g, 'oe')
        .replace(/ü/g, 'ue')
        .replace(/ß/g, 'ss')
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/(^-|-$)/g, '');
    return `${slug}-${jobId}`;
}

const KarriereJobCard = ({ job, translation, onShowDetails }) => {
    const { t } = useTranslations();
    const currentYear = new Date().getFullYear();

    const title = translation?.title || 'Job';
    const freePlätze = parseInt(job.anzahl) || 0;
    const location = formatLocation(job.arbeitsort);
    const slug = generateSlug(title, job.id);

    return (
        <div className="col-lg-6 col-md-12 mb-4">
            <div className="job-card">
                <div className="job-card__decoration" />
                <div className="job-card__content">
                    <h4 className="job-card__title">{title}</h4>

                    <div className="job-card__info-box">
                        <p className="job-card__info-text">
                            <span className="job-card__info-label">
                                {t('career_jobs_period')}:
                            </span>{' '}
                            <b className="job-card__info-value--green">{currentYear}</b>
                            <br />
                            <span className="job-card__info-label">
                                {t('career_jobs_availablePositions')}:
                            </span>{' '}
                            <span className={`job-card__info-value ${freePlätze > 0 ? 'job-card__info-value--green' : 'job-card__info-value--red'}`}>
                                {freePlätze}
                            </span>
                            <br />
                            <span className="job-card__info-label">
                                {t('career_jobs_location')}:
                            </span>{' '}
                            <span className="job-card__info-value--green">{location}</span>
                            {job.lohn_std && (
                                <>
                                    <br />
                                    <span className="job-card__info-label">
                                        {t('career_jobs_hourlyWage')}:
                                    </span>{' '}
                                    <span className="job-card__info-value--green">{job.lohn_std}€</span>
                                </>
                            )}
                        </p>
                    </div>

                    <div className="job-card__buttons">
                        <button
                            className="job-details-btn"
                            onClick={onShowDetails}
                        >
                            <BiInfoCircle /> {t('career_jobs_details')}
                        </button>
                        <Link href={`/karriere/${slug}`} className="job-details-btn job-details-btn--outline">
                            <BiLinkExternal /> {t('career_jobs_viewJob')}
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default KarriereJobCard;
